export { default as outputs } from './outputs/qa/amplify_outputs.json';
